import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import { useProductsTFunction } from '@retail/products/i18n';
import { MgItemPackages, MgPackageType } from '@retail/products/types';
import {
  desiredPackagingOrder,
  getClassCodeLabel,
  getPackageTypeLabel,
  sortMgItemPackages,
} from '@retail/products/utils';

interface Props {
  isSuperUser: boolean;
  packages: MgItemPackages;
  selectedPackage: string;
  setSelectedPackage: (selectedPackage: MgPackageType) => void;
}

export const MgPackagesButtonGroup = ({
  isSuperUser,
  packages,
  selectedPackage,
  setSelectedPackage,
}: Props) => {
  const t = useProductsTFunction();

  // @ts-ignore
  const sortedPackages: [MgPackageType, MgItemPackages[]][] =
    // @ts-ignore
    Object.entries(packages).sort(sortMgItemPackages);
  const emptyPackages = desiredPackagingOrder.filter((pkg) => !Object.keys(packages).includes(pkg));

  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      value={selectedPackage}
      onChange={(_, newView) => newView !== null && setSelectedPackage(newView)}
    >
      {Object.values(sortedPackages).map(([key]) => {
        if (key === 'ADDITIONAL_GTIN' && !isSuperUser) return null;
        return (
          <Tooltip key={key} title={getPackageTypeLabel(t, key)}>
            <ToggleButton value={key}>{getClassCodeLabel(key)}</ToggleButton>
          </Tooltip>
        );
      })}

      {emptyPackages.map((packaging) => (
        <Tooltip key={packaging} title={getPackageTypeLabel(t, packaging)}>
          <div>
            <ToggleButton value={packaging} disabled>
              {getClassCodeLabel(packaging)}
            </ToggleButton>
          </div>
        </Tooltip>
      ))}
    </ToggleButtonGroup>
  );
};
